import { HomeAnalyticsIcon } from './HomeAnalyticsIcon';

/**
 * author: Michael Richins
 * id 381A61B9-0D73-4CB8-B525-C67697443F43
 * name home-analytics
 * version: 3.7.94
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/home-analytics.svg
 * tags
 * - Home Automation 
 */
export const HomeReportIcon = HomeAnalyticsIcon;
export default HomeReportIcon